import { useTranslation } from "react-i18next";
import Millimetre from "../../../../../components/Math/Units/Metric/Millimetre";
import { NumberFormatText } from "../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../components/RowValue/RowBody";

function Innendurchmesser({ innendurchmesser }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.innerDiameter")}</p>}
      indicesValue={
        <span>
          D<sub>i</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={innendurchmesser} decimalScale={1} />
        </span>
      }
      unitValue={<Millimetre />}
    />
  );
}

export default Innendurchmesser;
